import { createSlice } from "@reduxjs/toolkit";

const userFilters = createSlice({
  name: "userFilters",
  initialState: {
    userFilters: null,
    isLoaded: false,
  },
  reducers: {
    getUserFilters(state) {
      return { ...state, isLoaded: false };
    },
    setUserFilters(state, action) {
      const update = action.payload;

      if (typeof update === 'function') {
        state.userFilters = update(state.userFilters);
      } else {
        state.userFilters = update; 
      }
      state.isLoaded = true;
    }
  },
});

export const {
  getUserFilters,
  setUserFilters,
} = userFilters.actions;

export default userFilters.reducer;
